import React, { Component} from "react";
import { Image, TouchableOpacity, View } from "react-native";
import TextView from "./TextView";
import { componentStyles, appStyles } from "../theme/styles";
import { greenDarkColor, greenLightColor } from "../theme/colors";
import LinearGradient from 'react-native-linear-gradient';
import Button from "./Button";
import { getStatus, persianNumber, getStatusColor } from "../utils/utils";

import { wp, hp } from "../utils/responsive";

export default class OrderItem extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        var item = this.props.data;
        return (
            <TouchableOpacity style={componentStyles.requestItem} activeOpacity={0.5} onPress={() => {
                this.props.navigation.navigate('orderInfo', {
                    data: item,
                    onRefresh: () => {
                        this.props.onRefresh()
                    }
                })
            }}>
                <View style={[appStyles.rowBetween, { flex: 1 }]}>
                    <View>
                        <TextView style={{ marginBottom: 25, fontSize: 12 }}>{persianNumber(item.datetime)}</TextView>
                        <Button
                            text='مشاهده'
                            style={[componentStyles.infoButton, { marginBottom: 5 }]}
                            textStyle={componentStyles.infoButtonText}
                            onPress={() => {
                                this.props.navigation.navigate('orderInfo', {
                                    data: item,
                                    onRefresh: () => {
                                        this.props.onRefresh()
                                    }
                                })
                            }}
                        />
                    </View>
                    <View>
                        <TextView style={[appStyles.rightText, { marginBottom: 20, fontSize: hp(1.8), width: wp(23) }]}>{item.title}</TextView>
                        <TextView style={[appStyles.rightText, { fontSize: hp(1.5), color: getStatusColor(item.showsession, item.statusorder, item.session) }]}>{getStatus(item.showsession, item.statusorder, item.session)}</TextView>
                    </View>

                </View>
                <LinearGradient colors={[greenDarkColor, greenLightColor]} style={componentStyles.requestImageWraper}>
                    <Image
                        source={{ uri: item.imageurl }}
                        style={componentStyles.serviceImage} />
                </LinearGradient>
            </TouchableOpacity>
        );
    }
}


